import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconArrowRight, IconMail } from '@redteclab/icons'

import { Button } from 'base-ui'

import { DirectContactPostCardDialog } from '../../../direct-contact'
import { useOpenableControls } from '../../../generic-hooks'

export const ContactPagePostCardLabel: FC = () => {
  const modalControlsPostDialog = useOpenableControls()

  return (
    <>
      <Button
        className="w-full"
        endIcon={<IconArrowRight className="fill-dark-brand" />}
        id="contact.page.post.label"
        key="contact.page.post.label"
        onClick={() => {
          modalControlsPostDialog.handleOpen()
        }}
        size="large"
        startIcon={<IconMail className="fill-dark-brand" />}
        variant="text"
      >
        <span className="grow text-start">
          <FormattedMessage id="contact.directContactSection.thirdCard.title" />
        </span>
      </Button>
      <DirectContactPostCardDialog
        onClose={modalControlsPostDialog.handleClose}
        open={modalControlsPostDialog.isOpen}
      />
    </>
  )
}
